import { Chip as MuiChip } from '@mui/material';

import Icon from '../../IconSvg/Icon';

export type LelyChipProps = {
  label: string;
  variant: 'dismissible' | 'selectable';
  disabled?: boolean;
  inverted?: boolean;
  dense?: boolean;
  isSelected?: boolean;
  onClick?: (selected: boolean) => void;
  onDelete?: () => void;
  'data-testid'?: string;
};

function LelyChip({
  label,
  variant,
  disabled = false,
  inverted = false,
  dense = false,
  isSelected = false,
  onDelete,
  onClick,
  'data-testid': dataTestId,
}: LelyChipProps) {
  const isSelectable = variant === 'selectable';
  const isDismissible = variant === 'dismissible';

  const handleSelectableClick = () => {
    if (onClick) onClick(!isSelected);
  };

  return (
    <MuiChip
      variant={variant}
      label={label}
      onClick={isSelectable ? handleSelectableClick : onDelete}
      onDelete={isDismissible ? onDelete : undefined}
      deleteIcon={isDismissible ? <Icon name="lely-icon-close" /> : undefined}
      data-selected={isSelectable && isSelected ? true : undefined}
      data-inverted={inverted || undefined}
      data-dense={dense || undefined}
      disabled={disabled}
      data-testid={dataTestId}
    />
  );
}

export default LelyChip;
